import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function SupplierSelect({ value, onChange, testId = "supplier-select", placeholder = "Tedarikçi seçin" }) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/suppliers").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  return (
    <Select value={value || "none"} onValueChange={(v) => onChange(v === "none" ? "" : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value="none">— Yok —</SelectItem>
        {list.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
